<template>
  <div style="height: 100vh;width: 100vw;">
    <!-- 页头 -->
    <nav-header2 style="position: absolute;z-index: 999;"></nav-header2>
    <div style="height: 50px;"></div>
    <div style="display: flex;height: calc(100% - 50px);width: 100%;">
      <!-- 侧边栏 -->
      <side-bar></side-bar>
      <div style="flex: 1;padding: 10px;background-color: #e4e7ed;display: flex;">
        <div class="content-box">
          <div>
            <div class="tab">
              <span style="color: #999999;">管理员管理</span>
            </div>
            <div class="title-box">
              <!-- 标题 -->
              <div class="title">菜单列表</div>
              <!-- 按钮 -->
              <div class="btn-box">
                <!-- <el-button>添加管理员</el-button> -->
                <div
                  class="btn"
                  @click="addadmin()"
                >添加菜单</div>
                <!-- <div
                  class="btn"
                  @click="deleteallshow()"
                >批量删除</div>
                <div class="btn">排序</div>
                <div
                  class="btn"
                  @click="exportExcel()"
                >
                  <img
                    class="exportimg"
                    src="../assets/img/export.png"
                  >
                  导出
                </div> -->
              </div>
            </div>

            <!-- 下拉选择框 -->
            <div class="select-box">
              <div class="select">
                <el-date-picker
                  @change="changestartdate()"
                  v-model="startdate"
                  type="date"
                  placeholder="注册日期（起）"
                >
                </el-date-picker>
              </div>
              <div class="select">
                <el-date-picker
                  @change="changestartdate()"
                  v-model="enddate"
                  type="date"
                  placeholder="注册日期（止）"
                >
                </el-date-picker>
              </div>
              <div class="select">
                <el-input
                  v-model="searchphone"
                  placeholder="请输入手机号"
                ></el-input>
              </div>
              <div
                class="search"
                @click="handleSearch()"
              >查询</div>
            </div>
            <div>
              <div class="networkListtitle">
                <div class="inputcheck">
                  <div
                    class="titlebox"
                    style="width: 32px;"
                  >
                    <el-checkbox
                      v-model="checkAll"
                      @change="checkall()"
                    ></el-checkbox>
                  </div>
                  <div class="username titlebox">
                    名称</div>
                </div>
                <div class="usermobile titlebox">描述</div>
                <div class="useremail titlebox">路径</div>
                <div class="userfirm titlebox">状态</div>
                <div class="userdate titlebox">注册日期</div>
                <div class="networknum titlebox">创建者</div>
                <!-- <div class="equipmentnum titlebox">设备数量</div> -->
                <div class="networkoperate titlebox">
                  <div style="width: 240px; ">操作</div>
                </div>
              </div>
            </div>
            <div>
              <div
                class="userList"
                v-for="i in displayedBoxes"
                :key="i.id"
              >
                <div class="inputcheck">
                  <div style="width: 32px;">
                    <el-checkbox v-model="i.checked"></el-checkbox>
                  </div>
                  <div class="username">{{ i.name }}</div>
                </div>
                <div class="usermobile">{{ i.desc }}</div>
                <div class="useremail">{{ i.url }}</div>
                <div class="userfirm"><el-switch
                    active-value="1"
                    inactive-value="0"
                    @change="switchtj(i)"
                    v-model="i.status"
                  >
                  </el-switch></div>
                <!-- <div
                  class="userfirm"
                  v-if="i.status != '1'"
                ><el-switch :v-model="false">
                  </el-switch></div> -->
                <div class="userdate">{{ time(i.date) }}</div>
                <div class="networknum">{{ i.phone }}</div>
                <!-- <div class="equipmentnum">{{ i.Memberslen }}/{{ i.equipmentnum }}</div> -->
                <div class="networkoperate">
                  <div
                    class="userkbtn"
                    @click="shownotice(i.id)"
                  >删除</div>
                  <div
                    class="userkbtn"
                    @click="changenumber(i)"
                  >编辑</div>
                </div>

                <!-- 删除用户 -->
                <div
                  v-if="i.id == delid"
                  class="notice"
                >
                  <div class="overlay"></div>
                  <div class="deleteallbox">
                    <div style="padding: 20px;">提示</div>
                    <div style="text-align: center;padding: 20px 30px">确定删除此菜单？删除后菜单信息将会被彻底清除！
                    </div>
                    <div style="margin-top: 16px;">
                      <div style="display: flex;justify-content: flex-end;">
                        <div
                          @click="shownotice(i)"
                          class="addbtn"
                          style="margin-left: 0px;"
                        >取消
                        </div>
                        <div
                          @click="userDelete(i.id)"
                          class="addbtn"
                          style="color: white;background-color: #012f55;margin-left: 20px;margin-right: 15px;margin-bottom: 20px;"
                        >
                          确定</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 设定数量 -->
            <div
              v-if="shownumber"
              class="notice"
            >
              <div class="overlay"></div>
              <div class="addbox">
                <div class="addtitle">设置数量</div>
                <div class="addtable">
                  <el-form
                    :rules="rules"
                    ref="form"
                    :model="form"
                    label-width="80px"
                  >
                    <el-form-item
                      label="网络数量"
                      prop="name"
                    >
                      <el-input
                        placeholder="请输入网络数量"
                        v-model="form.networknum"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="设备数量">
                      <el-input
                        placeholder="请输入设备数量"
                        v-model="form.equipmentnum"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="display: flex;justify-content: end;">
                    <div
                      class="addbtn"
                      @click="changenumber()"
                    >取消</div>
                    <div
                      class="addbtn"
                      @click="enternumber(i)"
                      style="background-color: #012f55;color: white;"
                    >确认
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 删除所有展示 -->
            <div v-if="alldelete">
              <div class="overlay"></div>
              <div class="deleteallbox">
                <div style="padding: 20px;">提示</div>
                <div style="text-align: center;padding: 20px 30px">确定删除所选菜单？删除后菜单信息将会被彻底清除！</div>
                <div style="margin-top: 16px;">
                  <div style="display: flex;justify-content: flex-end;">
                    <div
                      @click="deleteallcancel()"
                      class="addbtn"
                      style="margin-left: 0px;"
                    >取消
                    </div>
                    <div
                      @click="deleteallenter()"
                      class="addbtn"
                      style="color: white;background-color: #012f55;margin-left: 20px;margin-right: 15px;margin-bottom: 20px;"
                    >
                      确定</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <!-- 分页 -->
            <div class="currentpage">
              <button
                class="pagination"
                @click="goToPreviousPage()"
                :disabled="currentPage === 1"
                :class="{ 'pagination-hover': currentPage !== 1 }"
              >上一页</button>
              <span
                v-for="page in pages"
                :key="page"
              >
                <button
                  @click="goToPage(page)"
                  class="pagination2"
                  :class="{ 'pagination-active': page === currentPage }"
                >{{
                                    page }}</button>
              </span>
              <button
                class="pagination"
                @click="goToNextPage()"
                :class="{ 'pagination-hover': currentPage !== totalPages }"
                :disabled="currentPage === totalPages"
              >下一页</button>
              <span style="margin-left:10px;">总数：{{fuserList.length}}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogFormVisible"
      width="33%"
    >
      <el-form
        ref="formdata"
        :model="formdata"
        :inline="true"
      >
        <el-form-item
          label="上级"
          prop="name"
          :label-width="formLabelWidth"
        >
          <el-select
            class="el-input-search"
            v-model="formdata.xlname"
            ref="orgtxSelect"
            placeholder="顶级菜单"
            @remove-tag="removetag"
            @clear="clearall"
            clearable
            @change="$forceUpdate()"
            style="width: 300px"
          >
            <el-option
              disabled
              value=""
              style="height: auto; background-color: #fff"
              class="noDisabledCursor"
            >
              <el-input
                :validate-event="false"
                v-model="filterText"
                placeholder="请输入"
                @click.stop.native
                style="margin: 10px 0"
              ></el-input>
              <el-tree
                :data="orgList"
                default-expand-all
                highlight-current
                :expand-on-click-node="false"
                :check-on-click-node="true"
                :filter-node-method="filterNode"
                node-key="id"
                :props="defaultProps"
                @node-click="handleNodeClick"
                @check="handleNodeCheck"
                :check-strictly="true"
                class="dialogTree"
                ref="orgtxtree"
              ></el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="名称"
          prop="mobile"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formdata.name"
            minlength="11"
            maxlength="11"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="mobile"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formdata.desc"
            minlength="11"
            maxlength="11"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="路径"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formdata.url"
            minlength="1"
            maxlength="28"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="状态"
          :label-width="formLabelWidth"
        >
          <el-switch
            v-model="formdata.status"
            active-value="1"
            inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          label="排序"
          :label-width="formLabelWidth"
        >
          <el-input-number
            v-model="formdata.sortcd"
            controls-position="right"
            @change="handleChange"
            :min="1"
            :max="100"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="图标"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formdata.icon"
            placeholder="请选择图标"
          >
            <el-option
              v-for="(icon, index) in icons"
              :key="index"
              :label="icon"
              :value="icon"
            >
              <span style="float: left">{{ icon }}</span>
              <span style="float: right; color: #8492a6; margin-left: 10px">
                <!-- <el-icon :size="18">
                  <component :is="icon" />
                </el-icon> -->
                <i
                  size="mini"
                  :class="icon"
                ></i>
              </span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitData"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import excel from '@/libs/excel'
import bcrypt from 'bcryptjs';
export default {
  data() {
    return {
      selectedUser: null,
      alldelete: false,
      shownumber: false,
      dialogFormVisible: false,
      formLabelWidth: '70px',
      title: '添加菜单',
      startdate: '',
      enddate: '',
      ruleForm: {
        releasePerson: null,
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      orgList: [],//获取的树节点数据
      selectTree: [], //选中的树节点
      treeIds: [], //选中的id
      filterText: "",
      fuserList: [],
      userList: [],
      // dataList: [],
      search: '',
      searchphone: '',
      checkAll: '',
      currentPage: 1,
      itemsPerPage: 16,
      form: {
        networknum: '',
        equipmentnum: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入用户名/手机号', trigger: 'blur' },
          { min: 5, max: 18, message: '长度在 5 到 18 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, max: 18, message: '长度在 5 到 18 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      formdata: {
        name: '',
        desc: '',
        url: '',
        password: '',
        fid: '',
        xlname: '',
        issuper: '',
        sortcd: 1,
        icon: '',
        status: 1
      },
      delid: '',//删除时的临时id
      icons: [
        'el-icon-edit',
        'el-icon-share',
        'el-icon-delete',
        'el-icon-s-platform',
        'el-icon-monitor',
        'el-icon-basketball',
        'el-icon-setting'
      ]
    }
  },
  watch: {
    //type为user为第二层节点的数据 第一层的type为null
    selectTree(val) {
      if (val && val.length) {
        const list = val.filter((item) => item.type === "user");
        this.treeIds = list.map((item) => item.id);
        this.ruleForm.releasePerson = list.map((item) => item.label);
      }
    },
    //树节点模糊搜索
    filterText(val) {
      this.$refs.orgtxtree.filter(val);
    },
  },
  created() {
    this.$js.token();
    sessionStorage.setItem('tabid', '26');
    sessionStorage.setItem('path', '/Menudata');
    sessionStorage.setItem('netpage', '1');
    this.selectuser()
    this.changeheight()
  },
  computed: {
    displayedBoxes() {
      const startIndex = this.currentPage * this.itemsPerPage - this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage
      //return this.fuserList.slice(startIndex, endIndex)
      return this.fuserList;
    },
    totalPages() {
      return Math.ceil(this.fuserList.length / this.itemsPerPage)
    },
    pages() {
      const pages = [1];
      for (let i = 2; i <= this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    goToNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    //切换状态
    async switchtj(val) {
      //console.log(val)
      //let index = this.userList.indexOf(val.id);
      const contains = this.userList.find(item => item.fid === val.id) !== undefined;
      if (contains == true) { // 确保元素存在于数组中
        this.$message({
          message: '会同时关闭子菜单，谨慎操作',
          type: 'warning'
        });
        this.selectuser();
        return false;
      } else {
        let res = await this.$apiFun.editmenu(val);
        this.$message({
          message: res,
          type: 'success'
        });
        let id = JSON.parse(sessionStorage.getItem('user')).id
        let red = await this.$apiFun.selectmenu({ id });
        let issuper = JSON.parse(sessionStorage.getItem('user')).issuper
        let listjs = [];//获取授权的菜单id
        red.forEach(item => {
          if (item.name == issuper) {
            //listjs = item.yjqx.split(",");
            if (item.yjqx != null) {
              listjs = JSON.parse(item.yjqx);
              for (let d = 0; d < listjs.length; d++) {
                if (listjs[d].id == val.id) {
                  listjs.splice(d, 1);
                  item.yjqx = JSON.stringify(listjs);
                  let res = this.$apiFun.editrole(item);
                }
              }
            }
          }
        })
        this.selectuser();
      }
    },
    //添加管理员
    addadmin() {
      this.dialogFormVisible = true;
      this.title = '添加菜单';
      this.formdata.name = '';
      this.formdata.desc = '';
      this.formdata.url = '';
      this.formdata.password = '';
      this.formdata.issuper = '';
      this.formdata.xlname = '顶级菜单';
      this.formdata.status = '0';
      this.selectuser();
      //this.selectuser();
    },
    // 获取页面大小
    changeheight() {
      if (document.documentElement.clientHeight <= 800 && document.documentElement.clientHeight > 750) {
        this.itemsPerPage = 12
      } else if (document.documentElement.clientHeight <= 750 && document.documentElement.clientHeight > 720) {
        this.itemsPerPage = 11
      } else if (document.documentElement.clientHeight < 720) {
        this.itemsPerPage = 7
      }
    },
    // 删除成员
    async userDelete(id) {
      // console.log(id);
      let res = await this.$apiFun.deletemenu({ id })
      //alert(res)
      this.delid = '';
      this.selectuser();
    },
    // 展示删除框
    shownotice(item) {
      //   if (item.notice) {
      //     item.notice = !item.notice
      //   } else {
      //     this.fuserList.forEach(item => {
      //       item.notice = false
      //     })
      //     item.notice = !item.notice
      //   }
      this.delid = item;
    },
    //展示改变设备数量
    changenumber(i) {
      //   this.shownumber = !this.shownumber
      //   if (i) {
      //     this.selectedUser = i
      //     this.form.networknum = i.networknum
      //     this.form.equipmentnum = i.equipmentnum
      //   }
      this.dialogFormVisible = true;
      this.title = '编辑菜单';
      this.formdata = i;
      this.formdata.xlname = i.name;
    },
    //改变设备数量
    async enternumber() {
      let id = this.selectedUser.id
      let networknum = this.form.networknum
      let equipmentnum = this.form.equipmentnum
      let res = await this.$apiFun.changenumber({ id, networknum, equipmentnum })
      console.log(res);
      location.reload()
    },
    // 时间开始
    changestartdate() {
      this.fuserList = [];
      let start = this.startdate ? this.startdate.getTime() : 0;
      let end = this.enddate ? this.enddate.getTime() : Infinity;
      this.fuserList = this.userList.filter(item => {
        let itemDate = item.date
        return itemDate >= start && itemDate <= end;
      });

    },
    //批量删除
    deleteallshow() {
      const allFalse = this.fuserList.every(obj => obj.checked === false);
      if (allFalse) {
        alert('请选择需要删除的用户')
      } else {
        this.alldelete = true
      }
    },
    handleNodeClick(data, node) {
      if (!data.children && data.type === "user") {
        const nodeId = data.id; // 假设每个节点有一个唯一的 id 属性
        const selectedNodes = this.treeIds; // 获取当前选中的节点值数组
        const isChecked = node.checked; // 获取当前节点的选中状态
        if (isChecked && !selectedNodes.includes(nodeId)) {
          // 如果节点被选中且其值不在选中数组中，则添加该值
          //console.log(data, node);
          this.ruleForm.releasePerson = data.label;
          selectedNodes.push(nodeId);
        } else if (!isChecked && selectedNodes.includes(nodeId)) {
          // 如果节点被取消选中且其值在选中数组中，则移除该值
          const index = selectedNodes.indexOf(nodeId);
          if (index > -1) {
            selectedNodes.splice(index, 1);
          }
        }
        this.$forceUpdate();
      } else {
        //console.log(data, node);
        this.formdata.fid = data.id;
        this.formdata.xlname = data.name;
      }
    },
    handleNodeCheck(data, node) {
      if (!data.children && data.type === "user") {
        this.selectTree = [];
        node.checkedNodes.forEach((item) => {
          this.selectTree.push({
            id: item.id,
            label: item.label,
            type: item.type ? item.type : null,
          });
        });
      }
    },
    //点击select中删除按钮方法实现
    removetag(val) {
      let checkNodes = this.$refs.orgtxtree.getCheckedNodes();
      let keyArrList = this.$refs.orgtxtree.getCheckedKeys();
      let selectList = this.selectTree.map((x) => x.label);
      for (let i = 0; i < checkNodes.length; i++) {
        if (checkNodes[i].label == val) {
          if (checkNodes[i].children && checkNodes[i].children.length > 0) {
            keyArrList.splice(i, 1);
            this.selectTree.splice(selectList.indexOf(val), 1);
            this.del(checkNodes[i].children, keyArrList);
          } else {
            checkNodes.splice(i, 1);
            this.selectTree.splice(selectList.indexOf(val), 1);
            this.$refs.orgtxtree.setCheckedNodes(checkNodes);
          }
          break;
        }
      }
    },
    // 递归删除树组件选中状态
    del(arr, dataList) {
      for (let item of arr) {
        if (item.children && item.children.length > 0) {
          this.del(item.children);
        } else {
          dataList.splice(dataList.indexOf(Number(item.id)), 1);
        }
      }
      this.$nextTick(() => {
        this.$refs.orgtxtree.setCheckedKeys(dataList);
      });
    },
    clearall() {
      this.selectTree = [];
      this.treeIds = [];
      this.$nextTick(() => {
        this.$refs.orgtxtree.setCheckedNodes([]);
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      //console.log(value, data);
      if (data.name) {
        return data.name.indexOf(value) !== -1;
      }
    },
    deleteallcancel() {
      this.alldelete = false
    },
    deleteallenter() {
      const startIndex = this.currentPage * this.itemsPerPage - this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage
      this.fuserList.slice(startIndex, endIndex).forEach(async item => {
        if (item.checked == true) {
          let id = item.nwid
          let res = await this.$apiFun.deleteadmin({ id });
          //alert(res)
        }
      })
      this.alldelete = false;
      this.selectuser();
    },
    // 搜索功能
    handleSearch() {
      this.fuserList = [];
      this.userList.map(item => {
        if (item.mobile == this.searchphone) {
          this.fuserList.push(item);
        } else if (this.searchphone == "") {
          this.selectuser();
        }
      });
    },
    //验证方法
    async verificationbd(vala, valb) {
      if (vala == '') {
        this.$message({
          message: '请输入菜单名',
          type: 'warning'
        });
        return false;
      } else {
        if (valb == '') {
          this.$message({
            message: '请输入组件路径',
            type: 'warning'
          });
          return false;
        } else {
          if (this.title == '添加菜单') {
            let data = JSON.parse(sessionStorage.getItem('user'));
            this.formdata.username = data.name;
            this.formdata.parentid = data.parentid;
            let res = await this.$apiFun.addmenu(this.formdata);
            //alert("00")
          } else {
            let res = await this.$apiFun.editmenu(this.formdata);
            //alert("00")
          }
          this.dialogFormVisible = false;
          this.selectuser();
        }
      }
    },
    isValidEmail(email) {
      var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return emailRegex.test(email);
    },
    //提交数据
    async submitData() {

      //this.formdata.id = data.id
      this.verificationbd(this.formdata.name, this.formdata.url);
      //let res = await this.$apiFun.addnet({ netname, userid, username, parentid,label,project });

    },
    // 时间戳转换
    time(date) {
      let timestamp = parseInt(date);
      let time = new Date(timestamp);
      // 获取年、月、日
      let year = time.getFullYear();
      let month = ("0" + (time.getMonth() + 1)).slice(-2); // 月份是从0开始的，所以需要加1
      let day = ("0" + time.getDate()).slice(-2);
      // 格式化日期
      let formattedDate = year + "-" + month + "-" + day;
      return formattedDate
    },
    // 全选
    checkall() {
      this.fuserList.forEach(item => item.checked = this.checkAll)
    },
    //导出操作
    exportExcel() {
      let List = []
      this.fuserList.forEach(item => {
        if (item.checked == true) {
          List.push(item)
        }
      })
      if (List.length > 0) {
        const params = {
          title: ['账号', '电话', '邮箱', '注册日期', '网络数量', '设备数量'],
          key: ['name', 'mobile', 'email', 'date', 'networknum', 'equipmentnum'],
          data: List, // 数据源
          autoWidth: true, //autoWidth等于true，那么列的宽度会适应那一列最长的值
          filename: '客户数据'
        }
        excel.exportArrayToExcel(params)
      } else {
        alert('请勾选需要导出的网络')
      }
    },
    listToTree(list) {
      let map = {}, node, tree = [], i;
      for (i = 0; i < list.length; i++) {
        map[list[i].id] = i; // 初始化映射
        list[i].children = []; // 初始化children数组
      }
      for (i = 0; i < list.length; i++) {
        node = list[i];
        if (node.fid !== "0") { // 如果当前节点的parentId不是根节点的parentId，即不是根节点
          // 找到当前节点的父节点
          list[map[node.fid]].children.push(node);
        } else {
          tree.push(node); // 如果当前节点是根节点，将其添加到树结构中
        }
      }
      return tree;
    },
    //查询用户信息
    async selectuser() {
      let Memberslen = 0
      let networkslen = 0
      let id = JSON.parse(sessionStorage.getItem('user')).id
      let issuper = JSON.parse(sessionStorage.getItem('user')).issuper
      //let res = await this.$apiFun.selectadmin({ id, issuper });
      let res = await this.$apiFun.selectmenu({ id });
      // this.orgList.push({
      //   id: 1,
      //   name: '顶级菜单',
      //   children: []
      // });
      // this.orgList[0].children = this.listToTree(res);
      this.orgList = this.listToTree(res);
      //console.log(this.orgList);
      if (res == false) {
        //console.log(res);
      } else {
        this.userList = res.filter(item => item.id !== '1');
        this.fuserList = this.userList
      }
    },
    // 修改操作
    updata() {
      alert('修改还没做')
    }
  }
}
</script>

<style scoped>
.content-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 0 1.1%;
  background-color: white;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
}

.tab {
  font-size: 12px;
  padding-top: 10px;
  height: 38.8px;
  line-height: 38.8px;
}

.title-box {
  margin: 20px 0px 10px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.title {
  font-size: 14px;
  font-weight: bold;
}

.btn-box {
  margin: -15px 0px 0px 0px;
  display: flex;
}

.addbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 300px;
  z-index: 999;
  background-color: white;
}

.addtitle {
  padding: 25px 0px 0px 15px;
  font-size: 14px;
  font-weight: bold;
}

.addtable {
  margin-top: 40px;
  padding: 0px 80px;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.notice {
  color: #333333;
  z-index: 999;
}

.overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明黑色背景 */
  z-index: 999;
  /* 确保在上层 */
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: white !important;
}

.userkbtn:hover {
  color: #70c31d;
  cursor: pointer;
}

.exportimg {
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

.select-box {
  display: flex;
}

.select {
  margin: 0px 10px 20px 0px;
}

.search {
  margin: 0px 10px 20px 0px;
  line-height: 32px;
  padding: 0 16px;
  background-color: #012f55;
  color: white;
  cursor: pointer;
}

.networkListtitle {
  font-size: 14px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  padding: 0 8px;
  font-weight: bold;
  background-color: #fafafb;
}

.inputcheck {
  display: flex;
}

.username {
  width: 140px;
}

.select-box:deep(.el-input__inner) {
  width: 151px;
  height: 32px;
}

.select-box:deep(.el-date-editor.el-input, .el-date-editor.el-input__inner) {
  width: 150px;
}

.select-box:deep(.el-input__icon) {
  line-height: 32px;
}

.select:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.select:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.btn {
  display: flex;
  align-items: center;
  padding: 0px 16px;
  height: 32px;
  line-height: 32px;
  margin: 0px 10px 0px 0px;
  border: 1px solid #e7e9f1;
  cursor: pointer;
  font-size: 14px;
  color: #666666;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* width: 210px; */
  /* height: 100px; */
  z-index: 999;
  background-color: white !important;
}

.userList {
  display: flex;
  border-bottom: 1px solid #ebeef5;
  padding: 8px;
}
.userList:hover {
  background: #fafafb;
}

.usermobile {
  width: 12.3%;
  flex-shrink: 0;
}

.userfirm {
  width: 160px;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-shrink: 0;
}

.useremail {
  width: 228px;
  flex-shrink: 0;
}

.userdate {
  width: 180px;
  flex-shrink: 0;
}

.networknum {
  width: 9.22%;
  flex-shrink: 0;
}

.equipmentnum {
  width: 9.22%;
  flex-shrink: 0;
}

.networkoperate {
  position: relative;
  width: 100px;
  display: flex;
  justify-content: space-between;
}

.userkbtn {
  color: #337ab7;
  border: none;
  cursor: pointer;
  height: 100%;
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #012f55;
}

.inputcheck:deep(
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner
  ) {
  background: #012f55;
  border-color: #012f55;
}

.select:deep(.el-input__inner) {
  line-height: 32px;
}

.select:deep(.el-input__inner:hover) {
  border-color: #012f55;
}

.notice:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.notice:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.titlebox {
  padding: 8px 0px;
  border-top: 1px solid #e7e9f1;
  border-bottom: 1px solid #e7e9f1;
}

@media screen and (min-width: 1680px) {
  .titlebox {
    padding: 8px 0px;
    border: none;
  }

  .networkListtitle {
    background-color: #fafafb;
    border-top: 1px solid #e7e9f1;
    border-bottom: 1px solid #e7e9f1;
  }
}
</style>